import { useNotify, useRecordContext } from "react-admin";
import { Button, CircularProgress } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { settings } from "app";
import { fetchHtmlContent } from "server/fetchHtml";
import React, { useState } from "react";
import EmailPreviewModal from "./EmailPreviewModal";
import { notificationsRequests } from "api/notificationsApi";

const ViewButton = () => {
  const record = useRecordContext();
  const notify = useNotify();

  const [open, setOpen] = useState(false);
  const [emailHtml, setEmailHtml] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleClick = async e => {
    e.stopPropagation();
    setOpen(true);
    setLoading(true);
    setEmailHtml(null);

    const url = `${settings.gatewayApi}/${notificationsRequests.getEmailHtmlBody(record.id)}`;
    try {
      const html = await fetchHtmlContent(url);
      setEmailHtml(html);
    } catch (err) {
      notify(`Грешка при зареждане на HTML: ${err.message || "Неизвестна грешка"}`, { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setEmailHtml(null);
    setLoading(false);
  };

  return (
    <>
      <Button
        startIcon={loading ? <CircularProgress size={16} /> : <VisibilityIcon />}
        onClick={handleClick}
        size="small"
        disabled={loading}
      >
        Преглед
      </Button>

      {open && (
        <EmailPreviewModal
          open={open}
          onClose={handleClose}
          htmlContent={emailHtml}
          loading={loading}
        />
      )}
    </>
  );
};

export default ViewButton;
